import styled from 'styled-components'
import { media } from '../../../utils'

export const ConfiguratorSubHeader = styled.p`
  margin-bottom: 20px;
  font-size: 20px;
  ${media.desktop`font-size: 18px;`}
  ${media.tablet`font-size: 16px;`}
  ${media.phone`font-size: 16px;`}
`

export const ConfiguratorText = styled.p`
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 7px;
  overflow: hidden;
`

export const Icon = styled.div`
  float: left;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  margin-right: 10px;
  background-image: url(${(props) => props.img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`
Icon.defaultProps = {
  size: 40
}

export const HintText = styled.p`
  font-size: 12px;
  text-align: center;
  color: #5c5b5c;
`
export const SmallHintText = styled.p`
  font-size: 12px;
  color: #5c5b5c;
`



// WEBPACK FOOTER //
// ./src/components/atoms/configurator/index.tsx